var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.445 16.6875H6.55499C2.87249 16.6875 1.29749 15.1125 1.29749 11.43V11.3325C1.29749 8.00246 2.60999 6.39746 5.54999 6.11996C5.84999 6.09746 6.13499 6.32246 6.16499 6.62996C6.19499 6.93746 5.96999 7.21496 5.65499 7.24496C3.29999 7.46246 2.42249 8.57246 2.42249 11.34V11.4375C2.42249 14.49 3.50249 15.57 6.55499 15.57H11.445C14.4975 15.57 15.5775 14.49 15.5775 11.4375V11.34C15.5775 8.55746 14.685 7.44746 12.285 7.24496C11.9775 7.21496 11.745 6.94496 11.775 6.63746C11.805 6.32996 12.0675 6.09746 12.3825 6.12746C15.3675 6.38246 16.7025 7.99496 16.7025 11.3475V11.445C16.7025 15.1125 15.1275 16.6875 11.445 16.6875Z",
    fill: "#6E6B7B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.7225C8.6925 11.7225 8.4375 11.4675 8.4375 11.16V1.5C8.4375 1.1925 8.6925 0.9375 9 0.9375C9.3075 0.9375 9.5625 1.1925 9.5625 1.5V11.16C9.5625 11.475 9.3075 11.7225 9 11.7225Z",
    fill: "#6E6B7B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00001 12.5624C8.85751 12.5624 8.71501 12.5099 8.60251 12.3974L6.09 9.88488C5.8725 9.66738 5.8725 9.30738 6.09 9.08988C6.3075 8.87238 6.66751 8.87238 6.88501 9.08988L9.00001 11.2049L11.115 9.08988C11.3325 8.87238 11.6925 8.87238 11.91 9.08988C12.1275 9.30738 12.1275 9.66738 11.91 9.88488L9.3975 12.3974C9.285 12.5099 9.14251 12.5624 9.00001 12.5624Z",
    fill: "#6E6B7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.4b979d5d08bab53151d7c7ad1d6787b6.svg";
export { ForwardRef as ReactComponent };